import { cn } from '~/shadcn/lib/utils'

export function TextTableCell({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('scroll-m-20 text-base font-semibold', className)}
      {...props}
    />
  )
}
